import { Button, CircularProgress, TextField } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import React, { useEffect, useState } from "react";
import "./infoDetails.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getVocabularyContents,
  getVocabularyWordList,
  resetAddWordToListParams,
  resetDeleteWordParams,
  resetEditNoteParams,
  updateVocabularyEditWordNote,
  vocabularyAddWord,
  vocabularyAddWordToList,
} from "../../../../redux/actions/vocabularyCenterAction";
import { USER, VOCABULARY_ACTION, VOCABULARY_TYPE, VOCABULARY_WORDLIST } from "../../../../redux/constants";
import { LANGUAGE_ENGLISH, POS_DETAILS, TRANSLATION } from "../../VocabularyCenter/optionConstants";
import translate from "../../../../i18n/translate";
import { getParameterByName, getPosValue } from "../VocabularyCenterPOCUtils";
import { useEffectAfterMount } from "../../../common/hooks/useEffectAfterMount";
import { CloseIcon} from "../../../common/icon";
import DeleteWarning from "./partials/DeleteWarning";
import NoteEditor from "./partials/NoteEditor";
import SearchedContent from "./partials/searchContent";

const AddWords = ({
  showingWordListDetails,
  handleClose,
  infoDetails,
  newWordTitle,
  setShowAddWordList,
  addNewWord,
  setAddNewWord,
}: any) => {
  const dispatch = useDispatch();
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [isEditClicked, setIsEditClicked] = useState<boolean>(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState<boolean>(false);
  const [notes, setNotes] = useState<string>("");
  const reduxStore = useSelector((state: any) => state);
  const [searchedWord, setSearchedWord] = useState<any>({});
  const [usersLists, setUsersLists] = useState<any>([]);
  const [selectedUserList, setSelectedUserList] = useState<any>("");
  const [showAddToList, setShowAddToList] = useState<boolean>(false);
  const [newWordFormDetails, setNewWordFormDetails] = useState<any>({
    word: newWordTitle,
    def: "",
    translation: "",
    sentence: "",
    note: "",
    listId: "",
    posId: "",
    pos: "",
    slang: 0,
    type: USER,
  });

  useEffect(() => {
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      reduxStore.vocabularyContents.isWordSearching !== null &&
      !reduxStore.vocabularyContents.isWordSearching &&
      infoDetails === undefined
    ) {
      const isErrorOccurred = reduxStore.vocabularyContents.searchedWordError;
      if (reduxStore.vocabularyContents.isSearchedWordDetailsAvailable && Object.keys(isErrorOccurred).length < 1) {
        const searchedWord = reduxStore.vocabularyContents.searchedWordDetails.word;
        setSearchedWord(searchedWord[0]);
      } else {
        setSearchedWord({
          showMessage: true,
          message: translate("vocab_center_new_word_message"),
        });
      }
    }
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      reduxStore.vocabularyContents.editedNoteDetails &&
      Object.keys(reduxStore.vocabularyContents.editedNoteDetails).length > 0
    ) {
      const editNoteDetails = reduxStore.vocabularyContents.editedNoteDetails;
      if (searchedWord.defId === editNoteDetails.defId) {
        setSearchedWord({
          ...searchedWord,
          note: editNoteDetails.note,
        });
      } else if (searchedWord.defid === editNoteDetails.defId) {
        setSearchedWord({
          ...searchedWord,
          note: editNoteDetails.note,
        });
      }
    }
    if (reduxStore && reduxStore.vocabularyContents && reduxStore.vocabularyContents.headerLevelContents) {
      const usersListDetails = reduxStore.vocabularyContents.headerLevelContents["User"];
      const newUsersLists: any = [];
      if (usersListDetails && usersListDetails.userWordlists && usersListDetails.userWordlists.length > 0) {
        usersListDetails.userWordlists.forEach((userList: any) => {
          newUsersLists.push({
            listId: userList.listId,
            wordlist: userList.wordlist,
          });
        });
      }
      setUsersLists(newUsersLists);
      setNewWordFormDetails({ ...newWordFormDetails, listId: showingWordListDetails.listId });
    }
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      reduxStore.vocabularyContents.isWordNoteUpdated &&
      Object.keys(reduxStore.vocabularyContents.editedNoteDetails).length > 0
    ) {
      handleEditCloseView();
      getVocabularyContentsDetails();
      handleClose();
    }
    if (
      reduxStore &&
      reduxStore.vocabularyContents &&
      !reduxStore.vocabularyContents.isWordDeleting &&
      reduxStore.vocabularyContents.isWordDeleted
    ) {
      dispatch(resetDeleteWordParams());
      getVocabularyContentsDetails();
      handleClose();
    }
  }, [reduxStore]);

  useEffect(() => {
    if (infoDetails) {
      setSearchedWord({
        audioPath: infoDetails.audioPath,
        word: infoDetails.word,
        pos: infoDetails.pos,
        definition: infoDetails.definition,
        translation: infoDetails.translation === "" ? undefined : infoDetails["Translation"],
        sentence: infoDetails.sentence,
        note: infoDetails.notes,
        defId: infoDetails.defId,
        posId: infoDetails.posId,
        wordId: infoDetails.wordId,
        wordlist: infoDetails.wordlist,
        isDeletable: infoDetails.isDeletable,
        listId: infoDetails.listId,
      });
    }
  }, [infoDetails]);


  const handleNoteSaveEvent = () => {
    const SLANG = 0;
    try {
      dispatch(
        updateVocabularyEditWordNote(
          reduxStore.peopleInformation.data.getpeopleInformation.token,
          searchedWord.defId ?? searchedWord.defid,
          searchedWord.definition,
          searchedWord.sentence,
          notes,
          SLANG,
          parseInt(searchedWord.posId, 10),
        ),
      );
    } catch (error) {
      console.error("Failed to save note:", error);
      // Optionally, set an error state to display an error message to the user
    }
  };

  const handleEditCloseView = () => {
    setNotes("");
    setIsEditClicked(false);
    dispatch(resetEditNoteParams());
  };

  const handleAddWordToList = () => {
    dispatch(resetAddWordToListParams());
    try {
      dispatch(
        vocabularyAddWordToList(
          reduxStore.peopleInformation.data.getpeopleInformation.token,
          selectedUserList,
          searchedWord.wordId,
          VOCABULARY_TYPE,
          VOCABULARY_ACTION,
          VOCABULARY_WORDLIST,
        ),
      );
    } catch (error) {
      console.error("Failed to add word to list:", error);
      // Optionally, set an error state to display an error message to the user
    }
  };

  const getVocabularyContentsDetails = () => {
    const peopleInfoStateValidation = reduxStore.peopleInformation ? reduxStore.peopleInformation.data : "";
    const idParam = getParameterByName("id") ?? "";
    dispatch(
      getVocabularyContents(
        reduxStore.common.lgId,
        peopleInfoStateValidation.getpeopleInformation.token,
        parseInt(peopleInfoStateValidation.getpeopleInformation.accountId, 10),
      ),
    );
    dispatch(
      getVocabularyWordList(
        reduxStore.common.lgId,
        peopleInfoStateValidation.getpeopleInformation.token,
        idParam,
        TRANSLATION,
        LANGUAGE_ENGLISH,
      ),
    );
  };

  const handleAddNewWordAndSave = () => {
    const POS_NAME = getPosValue(newWordFormDetails.posId);
    dispatch(
      vocabularyAddWord(
        reduxStore.peopleInformation.data.getpeopleInformation.token,
        newWordFormDetails.def,
        newWordFormDetails.listId,
        newWordFormDetails.posId,
        POS_NAME,
        newWordFormDetails.sentence,
        newWordFormDetails.slang,
        newWordFormDetails.word,
        newWordFormDetails.type,
        newWordFormDetails.translation,
        newWordFormDetails.note,
      ),
    );
    setAddNewWord(false);
  };
  useEffectAfterMount(() => {
    if (!reduxStore.vocabularyContents.isWordCreating) {
      handleClose();
      getVocabularyContentsDetails();
    }
  }, [reduxStore.vocabularyContents.isWordCreating]);

  const renderContent = () => {
    if (searchedWord.showMessage === undefined && !addNewWord) {
      if (isDeleteClicked) {
        return (
          // Inside your component
          <DeleteWarning
            setIsDeleteClicked={setIsDeleteClicked}
            dispatch={dispatch}
            token={reduxStore.peopleInformation.data.getpeopleInformation.token}
            listId={searchedWord.listId}
            wordId={searchedWord.wordId}
            USER={USER}
          />
        );
      } else if (isEditClicked) {
        return (
          <NoteEditor
            handleEditCloseView={handleEditCloseView}
            isWordNoteUpdated={reduxStore.vocabularyContents.isWordNoteUpdated}
            notes={notes}
            setNotes={setNotes}
            handleNoteSaveEvent={handleNoteSaveEvent}
          />
        );
      } else {
        return (
          <SearchedContent
            searchedWord={searchedWord}
            handleClose={handleClose}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
            showAddToList={showAddToList}
            setShowAddToList={setShowAddToList}
            usersLists={usersLists}
            selectedUserList={selectedUserList}
            setSelectedUserList={setSelectedUserList}
            handleAddWordToList={handleAddWordToList}
            vocabularyContents={reduxStore.vocabularyContents}
            dispatch={dispatch}
            setIsDeleteClicked={setIsDeleteClicked}
            setIsEditClicked={setIsEditClicked}
            setShowAddWordList={setShowAddWordList}
          />
        );
      }
    }
    // Other conditions or return null if nothing matches
    return null;
  };
  return (
    <div className="add-words-container">
      {reduxStore.vocabularyContents.isWordSearching ||
      reduxStore.vocabularyContents.isWordNoteUpdating ||
      reduxStore.vocabularyContents.isWordAddingToList ||
      reduxStore.vocabularyContents.isWordDeleting ||
      reduxStore.vocabularyContents.isWordCreating ? (
        <div className="pop-up-loading">
          <CircularProgress size={25} color="primary" />
        </div>
      ) : (
        <>
          {searchedWord && Object.keys(searchedWord).length === 0 && addNewWord && (
            <div className="add-new-word-container">
              <div className="title-container">
                <p className="new-word-label">{translate("vocab_center_new_word_text")}</p>
                <CloseIcon className="close-icon" onClick={() => handleClose()} />
              </div>
              <div className="new-word-details-box">
                <div className="select-pos-list-details">
                  <FormControl className="pos-list-drop-down">
                    <InputLabel id="demo-simple-select-label" className="pos-list-label">
                      {translate("vocab_center_pos_label")}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={newWordFormDetails.posId}
                      onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, posId: e.target.value })}
                      className="pos-list-select-action"
                    >
                      {POS_DETAILS.map((list: any) => (
                        <MenuItem value={list.posId} className="pos-list-label" key={list.posId}>
                          {list.pos}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {usersLists.length === 0 ? (
                    <button
                      className="remove-button-default-style create-new-wordlist-title"
                      onClick={() => {
                        setShowAddWordList(true);
                      }}
                    >
                      + {translate("vocab_center_add_wordlist")}
                    </button>
                  ) : (
                    <FormControl className="user-list-drop-down">
                      <InputLabel id="demo-simple-select-label" className="user-list-label">
                        {translate("vocab_center_select_wordlist_text")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={newWordFormDetails.listId}
                        onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, listId: e.target.value })}
                        className="user-list-select-action"
                      >
                        {usersLists.map((list: any) => (
                          <MenuItem value={list.listId} className="users-list-label" key={list.listId}>
                            {list.wordlist}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </div>
                <div className="input-of-word">
                  <TextField
                    required
                    id="outlined-required"
                    label={translate("vocab_center_word_label")}
                    className="word-input"
                    value={newWordFormDetails.word}
                    // InputProps={{
                    //   readOnly: true,
                    // }}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, word: e.target.value })}
                  />
                  <TextField
                    required
                    id="outlined-required"
                    label={translate("vocab_center_definition_label")}
                    className="definition-input"
                    value={newWordFormDetails.def}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, def: e.target.value })}
                  />
                  <TextField
                    id="outlined-required"
                    label={translate("vocab_center_translation_label")}
                    className="translation-input"
                    value={newWordFormDetails.translation}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, translation: e.target.value })}
                  />
                  <TextField
                    id="outlined-required"
                    label={translate("vocab_center_sentence_label")}
                    className="sentence-input"
                    value={newWordFormDetails.sentence}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, sentence: e.target.value })}
                  />
                  <TextField
                    id="outlined-required"
                    label={translate("vocab_center_note_label")}
                    className="note-input"
                    value={newWordFormDetails.note}
                    onChange={(e) => setNewWordFormDetails({ ...newWordFormDetails, note: e.target.value })}
                  />
                </div>
                <div className="action-button-container">
                  <Button
                    variant="contained"
                    className="save-button-action"
                    disabled={
                      newWordFormDetails.word === "" ||
                      newWordFormDetails.def === "" ||
                      newWordFormDetails.posId === "" ||
                      newWordFormDetails.listId === ""
                    }
                    onClick={handleAddNewWordAndSave}
                  >
                    {translate("vocab_center_save_text")}
                  </Button>
                </div>
              </div>
            </div>
          )}
          {searchedWord && searchedWord.showMessage && Object.keys(searchedWord).length > 0 && (
            <div className="no-word-searched-container">
              <div className="title-container">
                <p className="new-word-label">{translate("vocab_center_new_word_text")}</p>
                <CloseIcon className="close-icon" onClick={() => handleClose()} />
              </div>
              <p className="no-work-searched-container-message">{searchedWord.message}</p>
              <div className="no-word-searched-actions">
                <Button
                  variant="contained"
                  className="no-work-searched-action-btn-1"
                  onClick={() => {
                    setSearchedWord({});
                    setAddNewWord(true);
                  }}
                >
                  {translate("vocab_center_add_text")}
                </Button>
                <Button variant="contained" className="no-work-searched-action-btn-2" onClick={() => handleClose()}>
                  {translate("vocab_center_cancel_text")}
                </Button>
              </div>
            </div>
          )}
          {renderContent()}
        </>
      )}
    </div>
  );
};

export default AddWords;
